import { render, staticRenderFns } from "./UdlBrainNetworkInfographic.vue?vue&type=template&id=304e54f7&scoped=true"
import script from "./UdlBrainNetworkInfographic.vue?vue&type=script&lang=js"
export * from "./UdlBrainNetworkInfographic.vue?vue&type=script&lang=js"
import style0 from "./UdlBrainNetworkInfographic.vue?vue&type=style&index=0&id=304e54f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304e54f7",
  null
  
)

export default component.exports